export default __webpack_public_path__ + "static/media/pin.dc79b84a.svg";